import {
  PRODUCTION_FLAG as PRODUCTION,
  ALPHA_FLAG as ALPHA,
  BETA_FLAG as BETA,
  GAMMA_FLAG as GAMMA,
  ARCHIVED_FLAG as ARCHIVED,
  PRIVATE_FLAG as PRIVATE,
} from "../utils/constants";

export const flagArray = (flag: string): Array<string | undefined> => {
  let flagArray = [PRODUCTION];
  if (flag === ALPHA) {
    flagArray = [ALPHA, BETA, GAMMA, PRODUCTION];
  } else if (flag === BETA) {
    flagArray = [BETA, GAMMA, PRODUCTION];
  } else if (flag === GAMMA) {
    flagArray = [GAMMA, PRODUCTION];
  } else if (flag === PRIVATE) {
    flagArray = [PRIVATE, ALPHA, BETA, GAMMA, PRODUCTION];
  } else if (flag === ARCHIVED) {
    flagArray = [ARCHIVED, ALPHA, BETA, GAMMA, PRODUCTION];
  }
  return flagArray;
};

export const permittedFlag = (
  activityFlag: string | undefined,
  questionFlag: string | undefined,
): boolean => {
  const notNullActivityFlag = activityFlag || PRODUCTION;
  const notNullQuestionFlag = questionFlag || PRODUCTION;
  return flagArray(notNullActivityFlag).includes(notNullQuestionFlag);
};
